import { render, staticRenderFns } from "./AccountingPayroll.vue?vue&type=template&id=06b28d8b"
import script from "./AccountingPayroll.vue?vue&type=script&lang=js"
export * from "./AccountingPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports